import moment from 'moment';
import { CHART_INTERVAL, DATE_FORMAT, ROLES } from '../Constants';
import { chargingPointsErrorMsg, usersErrorMsg } from './errorMessages.js';
import isEmail from 'validator/es/lib/isEmail.js';

export const dateFormatting = (value) => {
  if (value) {
    return moment(value).local().format('MMM Do, h:mm  A');
  } else {
    return null;
  }
};

export const getChartInterval = (interval) => {
  const duration = moment.duration(interval.end.diff(interval.start));
  const days = duration.asDays();
  let chartInterval;
  switch (true) {
    case days < 2:
      chartInterval = CHART_INTERVAL.min_5;
      break;
    case days < 5:
      chartInterval = CHART_INTERVAL.hour_1;
      break;
    case days < 8:
      chartInterval = CHART_INTERVAL.hour_6;
      break;
    default:
      chartInterval = CHART_INTERVAL.day_1;
      break;
  }
  return chartInterval;
};
export const getDateTimeFormat = (interval) => {
  const duration = moment.duration(interval.end.diff(interval.start));
  const days = duration.asDays();
  let chartInterval;
  switch (true) {
    case days < 2:
      chartInterval = DATE_FORMAT.hour;
      break;
    default:
      chartInterval = DATE_FORMAT.day;
      break;
  }
  return chartInterval;
};

// todo: rename this to make it clear that it refers to logged in user
export const returnLoggedInUserRole = (role) => {
  const isAdmin = !!role.find((role) => role.name === ROLES.ADMIN);
  const isSuperAdmin = !!role.find((role) => role.name === ROLES.SUPER_ADMIN);

  return {
    isAdmin,
    isSuperAdmin
  };
};

export const phoneNrValidator = (value) => {
  //https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s03.html
  const pattern = /^\+?(?:\d ?){6,14}\d$/;
  return pattern.test(value);
};

export const phoneNrValidatorWithMessage = (value) => {
  return phoneNrValidator(value) || usersErrorMsg.contact_phone;
};

export const organizationNameValidator = (value) => {
  return (value.length >= 3 && value.length <= 20) || usersErrorMsg.organization_name;
};

export const emailValidator = (value) => {
  return isEmail(value) || usersErrorMsg.email;
};

export const userNameValidator = (value) => {
  return (value.length >= 3 && value.length <= 20) || usersErrorMsg.username;
};

export const latitudeValidator = (value) => {
  // If no value is provided, validation passes (field is optional)
  if (isNaN(value)) {
    return true;
  }

  // Otherwise validate the value
  return (isFinite(value) && Math.abs(value) <= 90) || 'latitude_error';
};
export const longitudeValidator = (value) => {
  // If no value is provided, validation passes (field is optional)
  if (isNaN(value)) {
    return true;
  }

  // Otherwise validate the value
  return (isFinite(value) && Math.abs(value) <= 180) || 'longitude_error';
};

export const passwordValidator = (value) => {
  return value.length >= 6 || usersErrorMsg.password;
};

export const strongPasswordValidator = (value) => {
  // Check for minimum length
  if (value.length < 8) {
    return 'Password must be at least 8 characters';
  }

  // Check for lowercase letter
  if (!/(?=.*[a-z])/.test(value)) {
    return 'Password must contain at least one lowercase letter';
  }

  // Check for uppercase letter
  if (!/(?=.*[A-Z])/.test(value)) {
    return 'Password must contain at least one uppercase letter';
  }

  // Check for number
  if (!/(?=.*[0-9])/.test(value)) {
    return 'Password must contain at least one number';
  }

  // Check for special character
  if (!/(?=.*[@$!%*?&])/.test(value)) {
    return 'Password must contain at least one special character (@, $, !, %, *, ?, &)';
  }

  // Check for valid characters
  if (!/^[A-Za-z\d@$!%*?&]+$/.test(value)) {
    return 'Password contains invalid characters';
  }

  // If all checks pass
  return true;
};

export const cpIdValidator = (value) => {
  return value.length >= 2 || value.length <= 20 || chargingPointsErrorMsg.cp_id;
};

export const preventNonPhoneCharacters = (e) => {
  //only use onBeforeInput
  const notDigitAndPlus = /[^\d+ ]/; // Also allows + and space characters
  notDigitAndPlus.test(e.data) && e.preventDefault();
};

export const preventNonPrice = (e, separator = '.', maxDecimal = 3) => {
  // only use onBeforeInput
  const allowedCharacters = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', separator];
  const value = e.target.value;
  const character = e.data;
  const separatorIndex = value.indexOf(separator);
  const maxDecimalReached = separatorIndex > -1 && value.length - 1 - separatorIndex >= maxDecimal;
  if (!allowedCharacters.includes(character) || maxDecimalReached) {
    e.preventDefault();
  } else if (value.includes(separator) && character === separator) {
    e.preventDefault();
  }
};
